module.exports = __webpack_public_path__ + "static/img/shop.bea0b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/share/images/shop.png
// module id = J5sw
// module chunks = 52